import { apiRoutes } from "../routes"
import { usePost } from "../utils/reactQuery"

export const usePrintHistoryPdf = () => {
    const context = usePost(apiRoutes.printPdf);
    return context;
}